module.exports = __webpack_public_path__ + "img/bend_radius.374e0f2b.svg";